import * as React from "react"
import * as Immutable from 'immutable'

import { RentalAdvert } from "../../../types/types";

type Props = {
  adverts: Immutable.List<RentalAdvert>
}

export default (props: Props) : JSX.Element => (
  <>
    {
      props.adverts.map((a) => (
        <article className='accommodation' key={a.id}>
          <div className='box box--horizontal'>
            <a title={a.objectName} className="box__inner" href={a.path}>
              <div className='box__cell'>
                <div className='box__visual' style={a.overviewImage ? { backgroundImage: `url(${a.overviewImage.url})` } : {}}>
                  {
                    a.overviewImage ?
                      <img src={a.overviewImage.url} alt={a.objectName}/>
                    : ''
                  }
                </div>
                <div className='box__text'>
                  <p className='box__title'>{a.objectName}</p>
                  <p className='box__subtitle'>{a.city.name}</p>
                </div>
              </div>
            </a>
          </div>
        </article>
    ))}
  </>
)
